export function sequence(length: number): number[] {
  const seq: number[] = []
  for (let i = 0; i < length; i++) {
    seq.push(i)
  }
  return seq
}

export function repeat<T>(length: number, obj: T): T[] {
  return sequence(length).map(() => ({ ...obj }))
}

export function flatSingle<T>(arr: T[][]): T[] {
  return [].concat(...(arr as any))
}
